import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Box,
  ButtonBase,
  ClickAwayListener,
  Grid,
  Paper,
  Popper,
  Stack,
  Tab,
  Tabs,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  FormControl,
  InputLabel,
  TextField,
  FormHelperText
} from '@mui/material';

// project import
import ProfileTab from './ProfileTab';
import Avatar from 'components/@extended/Avatar';
import MainCard from 'components/MainCard';
import Transitions from 'components/@extended/Transitions';

// assets
import avatar1 from 'assets/images/users/avatar-1.png';
import { UserOutlined } from '@ant-design/icons';
import jwt from 'jsonwebtoken';
import { putCambioContrasena } from '../../../../../services/login';
import { useFormik } from 'formik';

// tab panel wrapper
function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} id={`profile-tabpanel-${index}`} aria-labelledby={`profile-tab-${index}`} {...other}>
      {value === index && children}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `profile-tab-${index}`,
    'aria-controls': `profile-tabpanel-${index}`
  };
}

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

const Profile = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      localStorage.removeItem('token');
      navigate(`/login`, {
        state: {
          from: ''
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const [value, setValue] = useState(0);
  const [openModalContrasena, setOpenModalContrasena] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const obtenerNombreLogeado = () => {
    let token = localStorage.getItem('token');
    const decodedToken = jwt.decode(token);
    if (decodedToken) {
      return decodedToken.Name;
    }
  };

  const iconBackColorOpen = theme.palette.mode === 'dark' ? 'grey.200' : 'grey.300';
  const [errorMensaje, setErrorMensaje] = useState('');
  const formikContrasena = useFormik({
    initialValues: {
      contrasenaActual: '',
      contrasenaNueva1: '',
      contrasenaNueva2: ''
    },
    onSubmit: async (values) => {
      let response = await putCambioContrasena(values.contrasenaActual, values.contrasenaNueva1);
      if (response.exito) {
        localStorage.setItem('token', response.datos);
        setOpenModalContrasena(false);
      } else setErrorMensaje('Su contraseña actual es incorrecta');
    }
  });

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <ButtonBase
        sx={{
          p: 0.25,
          bgcolor: open ? iconBackColorOpen : 'transparent',
          borderRadius: 1,
          '&:hover': { bgcolor: theme.palette.mode === 'dark' ? 'secondary.light' : 'secondary.lighter' },
          '&:focus-visible': {
            outline: `2px solid ${theme.palette.secondary.dark}`,
            outlineOffset: 2
          }
        }}
        aria-label="open profile"
        ref={anchorRef}
        aria-controls={open ? 'profile-grow' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        <Stack direction="row" spacing={2} alignItems="center" sx={{ p: 0.5 }}>
          <Avatar alt="profile user" src={avatar1} size="xs" />
          <Typography variant="subtitle1">{obtenerNombreLogeado()}</Typography>
        </Stack>
      </ButtonBase>
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 9]
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Transitions type="grow" position="top-right" in={open} {...TransitionProps}>
            <Paper
              sx={{
                boxShadow: theme.customShadows.z1,
                width: 290,
                minWidth: 240,
                maxWidth: 290,
                [theme.breakpoints.down('md')]: {
                  maxWidth: 250
                }
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard elevation={0} border={false} content={false}>
                  {/* <CardContent sx={{ px: 2.5, pt: 3 }}>
                    <Grid container justifyContent="space-between" alignItems="center">
                      <Grid item>
                        <Stack direction="row" spacing={1.25} alignItems="center">
                          <Avatar alt="profile user" src={avatar1} sx={{ width: 32, height: 32 }} />
                          <Stack>
                            <Typography variant="h6">{user?.name}</Typography>
                            <Typography variant="body2" color="textSecondary">
                              UI/UX Designer
                            </Typography>
                          </Stack>
                        </Stack>
                      </Grid>
                      <Grid item>
                        <Tooltip title="Logout">
                          <IconButton size="large" sx={{ color: 'text.primary' }} onClick={handleLogout}>
                            <LogoutOutlined />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </CardContent> */}

                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs variant="fullWidth" value={value} onChange={handleChange} aria-label="profile tabs">
                      <Tab
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                          alignItems: 'center',
                          textTransform: 'capitalize'
                        }}
                        icon={<UserOutlined style={{ marginBottom: 0, marginRight: '10px' }} />}
                        label="Perfil"
                        {...a11yProps(0)}
                      />
                      {/* <Tab
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                          alignItems: 'center',
                          textTransform: 'capitalize'
                        }}
                        icon={<SettingOutlined style={{ marginBottom: 0, marginRight: '10px' }} />}
                        label="Setting"
                        {...a11yProps(1)}
                      /> */}
                    </Tabs>
                  </Box>
                  <TabPanel value={value} index={0} dir={theme.direction}>
                    <ProfileTab handleLogout={handleLogout} setOpenModalContrasena={setOpenModalContrasena} />
                  </TabPanel>
                  {/* <TabPanel value={value} index={1} dir={theme.direction}>
                    <SettingTab />
                  </TabPanel> */}
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
      <Dialog
        open={openModalContrasena}
        onClose={() => {
          setOpenModalContrasena(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <form onSubmit={formikContrasena.handleSubmit}>
          <Box sx={{ p: 1, py: 1.5 }}>
            <DialogTitle id="alert-dialog-title">Cambio de contraseña</DialogTitle>
            <DialogContent>
              <Grid item xs={12} sm={6}>
                <Stack spacing={0.5}>
                  <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel />
                    <TextField
                      fullWidth
                      id="contrasenaActual"
                      label="Contraseña actual"
                      name="contrasenaActual"
                      value={formikContrasena.values.contrasenaActual}
                      type="password"
                      onChange={formikContrasena.handleChange}
                    />
                  </FormControl>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Stack spacing={0.5}>
                  <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel />
                    <TextField
                      fullWidth
                      id="contrasenaNueva1"
                      label="Nueva contraseña"
                      name="contrasenaNueva1"
                      value={formikContrasena.values.contrasenaNueva1}
                      type="password"
                      onChange={formikContrasena.handleChange}
                    />
                  </FormControl>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Stack spacing={0.5}>
                  <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <InputLabel />
                    <TextField
                      fullWidth
                      id="contrasenaNueva2"
                      label="Repita su nueva contraseña"
                      name="contrasenaNueva2"
                      value={formikContrasena.values.contrasenaNueva2}
                      type="password"
                      onChange={formikContrasena.handleChange}
                    />
                    {formikContrasena.values.contrasenaNueva1 != formikContrasena.values.contrasenaNueva2 &&
                      formikContrasena.values.contrasenaNueva2 != '' && (
                        <FormHelperText error id="standard-weight-helper-text-email-login">
                          {' '}
                          {'Las contraseñas nuevas deben ser iguales'}
                        </FormHelperText>
                      )}
                    {errorMensaje != '' && (
                      <FormHelperText error id="standard-weight-helper-text-email-login">
                        {' '}
                        {errorMensaje}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Stack>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                color="error"
                onClick={() => {
                  setOpenModalContrasena(false);
                }}
              >
                Cancelar
              </Button>
              <Button
                variant="contained"
                onClick={() => {}}
                autoFocus
                type="submit"
                disabled={
                  !(
                    formikContrasena.values.contrasenaNueva1 == formikContrasena.values.contrasenaNueva2 &&
                    formikContrasena.values.contrasenaActual != '' &&
                    formikContrasena.values.contrasenaActual != '' &&
                    formikContrasena.values.contrasenaNueva1 != ''
                  )
                }
              >
                <Typography variant="h4">Confirmar</Typography>
              </Button>
            </DialogActions>
          </Box>
        </form>
      </Dialog>
    </Box>
  );
};

export default Profile;
